<template>
  <div>
    <div class="tw-mb-3">
      <!-- Title -->
      <div class="tw-text-base tw-text-infinity-secondary-text tw-font-medium">
        Previews
      </div>
    </div>
    <div>
      <SoundkitItem v-for="sample in soundkit.samples"
                    :name="sample.original_filename"
                    :key="sample.id"
                    :soundkit="soundkit"
                    :size="getSampleSize(sample)"
                    :duration="getSampleDuration(sample)"
                    :sample="sample"
                    is-sample />
    </div>
  </div>
</template>
<script>
import SoundKit from "../../../models/soundkit";
import SoundkitItem from "./soundkit-item";

export default {
  components: { SoundkitItem },
  props: {
    soundkit: {
      type: SoundKit,
      required: true
    }
  },
  methods: {
    getSampleSize(sample) {
      return `${Math.ceil(+sample.size * 0.001)}Kb`
    },
    getSampleDuration(sample) {
      const [minutes, seconds] = sample.duration_string.split(':')
      return `${minutes.length === 1 ? '0' : ''}${minutes}:${seconds}${seconds.length === 1 ? '0' : ''}`
    }
  }
}
</script>
